export default "__VITE_ASSET__ODNfuTpU__"